module.exports = __webpack_public_path__ + "static/media/black-undo-measure-icon.46e9ca10.svg";